import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {ReactComponent as Bank} from '../../../assets/new-icons/bank2.svg';
import {ReactComponent as Card} from '../../../assets/new-icons/card.svg';
import {ReactComponent as Change} from '../../../assets/new-icons/change.svg';

function PayMethod() {
    const navigate = useNavigate()
    const defaultMethod = useSelector((user) => user.gas.datiPagamento.method_name)
    const token = useSelector((user) => user.gas.datiPagamento.token)
    const iban = useSelector((user) => user.gas.datiPagamento.account_iban)

    return (
        <div className="payMethod">
            <p className="label">Metodo pagamento preferito</p>
            <div className="payMethodBox">
                {defaultMethod === "RID" ? (
                    <>
                        <div className="icon">
                            <Bank />
                        </div>
                        <div className="info">
                            <p className='secondary'>Iban</p>
                            <p className='number'><span className='hide'>1231233322</span>
                                {iban && iban.slice(iban.length - 4)}
                            </p>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="icon">
                            <Card />
                        </div>
                        <div className="info">
                            <p className='secondary'>Carta di credito</p>
                            <p className='number'><span className='hide'>1231233322</span>
                                {token && token.slice(token.length - 4)}
                            </p>
                        </div>
                    </>
                )}
                
                <div className="line"></div>
                <div className="iconChange" onClick={() => navigate('/enrica/cambio-metodo-gas')}>
                    <div className="change">
                        <Change />
                    </div>
                    <div className="labelChange">Cambia</div>
                </div>
            </div>
        </div>
  );
}

export default PayMethod;
